 

setTimeout(function(){

  var isLoggedIn = document.body && (
    document.body.getAttribute('data-customer-logged-in') === 'false' ||
    document.body.getAttribute('data-customer-logged-in') === '0'
  );

  // 🔥 Jos käyttäjä on kirjautunut, älä tee mitään 
  if (isLoggedIn) return;


  var priceElements = document.querySelectorAll('[data-product-variant-id] .price.money');
  [...priceElements].forEach(price => {
    var priceNum = Number(price.innerText.replace(" €", "").replace(",", "."));
    var priceWithTax = document.getElementById('vat24-price');
    var vat24Price = (priceNum*1.255).toFixed(2);
    if (priceWithTax) {
      priceWithTax.textContent = String(vat24Price).replace(".", ",") + " €";
    }
  });

  var vatPrices2 = document.querySelectorAll('[data-product-id]');
  [...vatPrices2].forEach(vatPrice => {
    var productId = vatPrice.getAttribute('data-product-id');
    var stringID = 'vat-' + productId;
    var priceNum = Number(vatPrice.textContent.replace(" €", "").replace(",", "."));
    var vat24Price = (priceNum*1.255).toFixed(2);
    var priceWithTax = document.getElementById(stringID);
    if (priceWithTax) {
      priceWithTax.textContent = String(vat24Price).replace(".", ",") + " €"; 
    }
  });

  var vatPrices = document.querySelectorAll('[data-product-id] .price');
  [...vatPrices].forEach(vatPrice => {
    var productId = vatPrice.getAttribute('data-product-id');
    var stringID = 'vat-' + productId;
    var priceNum = Number(vatPrice.textContent.replace(" €", "").replace(",", "."));
    var vat24Price = (priceNum*1.255).toFixed(2);
    var priceWithTax = document.getElementById(stringID);
    if (priceWithTax) {
      priceWithTax.innerHTML = String(vat24Price).replace(".", ",") + " €";
    }
  });

}, 300);






 

 







/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 
/*

addEventListener("load", () => {
  var saldoContainer = document.getElementById("jalleenmyyjan-varastossa");
  var skuContainer = document.getElementById("jalleenmyyjan-sku");
  if (saldoContainer && globalVarTable) {
    document.addEventListener('variant:changed', function(event) {
      console.log(event.detail.variant.sku);
      var variant = event.detail.variant;
      let saldoTrue = varQtyTable[variant.id];
      let saldoFri = globalVarTable[variant.id];
      if (saldoTrue <= 5 && saldoFri > 0){
      saldoContainer.disabled = false;
      skuContainer.disabled = false;
      saldoContainer.value = "Tarkista saldo" + "(" + saldoFri + ")"; 
      skuContainer.value = event.detail.variant.sku;
      } else {
        saldoContainer.disabled = true;
        skuContainer.disabled = true;
        saldoContainer.value = ""; 
      }
    });
  }
});

*/


 


 
 
/*

(function () {
  function isLoggedIn() {
    var v = document.body && document.body.getAttribute('data-customer-logged-in');
    return v === '1' || v === 'true' || v === 'yes';
  }

  function run() {
    if (!isLoggedIn()) return;

    document.querySelectorAll('.block-swatch[orig-value]').forEach(function (el) {
      var val = (el.getAttribute('orig-value') || '').toLowerCase();

      if (val.indexOf('mittatilaus') !== -1) {
        // VAIN visuaalinen piilotus (ei kosketa inputteihin)
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('variant:changed', run);
})();


*/








 





/********************************************************************
 * PRICE DEBUG BLOCK – turvallinen, vain logit.
 * Käynnistyy kun osoitteessa on ?debug_prices=1
 ********************************************************************/

/*
(function(){
  var qs = new URLSearchParams(location.search);
  var enabled = qs.has('debug_prices') || localStorage.getItem('debug_prices') === '1';
  if (!enabled) return;

  console.log('%c[PriceDebug] enabled','background:#222;color:#0f0;padding:2px 4px;border-radius:3px');

  function getPriceNodes(){
    var nodes = Array.from(document.querySelectorAll(
      '.bold-product-price, .price-list.price.money, .product__price, .price .money, .money'
    ));
    return nodes.filter((n,i,a)=>a.indexOf(n)===i);
  }

  console.groupCollapsed('[PriceDebug] BOLD presence');
  console.log('window.BOLD =', !!window.BOLD, window.BOLD);
  console.log('helpers.reloadPrices =', !!(window.BOLD && BOLD.helpers && BOLD.helpers.reloadPrices));
  console.log('utils.reloadPrices   =', !!(window.BOLD && BOLD.utils && BOLD.utils.reloadPrices));
  console.groupEnd();

  var priceNodes = getPriceNodes();
  console.groupCollapsed('[PriceDebug] price nodes ('+priceNodes.length+')');
  priceNodes.forEach((n,idx)=>{
    console.log('#'+idx, n, 'text=', n.textContent.trim());
  });
  console.groupEnd();

  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      var host = m.target.nodeType === 3 ? m.target.parentNode : m.target;
      if (!host) return;
      var pn = host.closest('.bold-product-price, .price-list.price.money, .product__price, .price, .money');
      if (pn) {
        console.log('[PriceDebug] price text changed →', pn.textContent.trim(), pn);
      }
    });
  });
  priceNodes.forEach(function(n){
    mo.observe(n, {childList:true, characterData:true, subtree:true});
  });

  function onVariantChange(e){
    var v = (e.detail && (e.detail.variant || e.detail.selectedVariant)) || null;
    if (!v) {
      console.warn('[PriceDebug] variant change event without variant payload', e);
      return;
    }
    console.group('[PriceDebug] variant changed');
    console.log('id:', v.id, 'sku:', v.sku, 'title:', v.title);
    console.log('price (cents):', v.price, 'compare_at (cents):', v.compare_at_price);
    console.table([
      {option:'option1', value:v.option1},
      {option:'option2', value:v.option2},
      {option:'option3', value:v.option3}
    ]);

    try {
      if (window.BOLD && BOLD.helpers && BOLD.helpers.reloadPrices) {
        console.log('[PriceDebug] calling BOLD.helpers.reloadPrices()');
        BOLD.helpers.reloadPrices();
      } else if (window.BOLD && BOLD.utils && BOLD.utils.reloadPrices) {
        console.log('[PriceDebug] calling BOLD.utils.reloadPrices()');
        BOLD.utils.reloadPrices();
      }
    } catch(err){
      console.warn('[PriceDebug] Bold reloadPrices threw:', err);
    }
    console.groupEnd();
  }
  document.addEventListener('variant:changed', onVariantChange);
  document.addEventListener('product:variant:change', onVariantChange);

  window.disablePriceDebug = function(){
    mo.disconnect();
    localStorage.removeItem('debug_prices');
    console.log('[PriceDebug] disabled (reload page to stop listeners)');
  };
})();

*/

  

 
/*

document.addEventListener("DOMContentLoaded", function() {
  // Haetaan kaikki seurattavat lomakkeet
  const forms = document.querySelectorAll(
    "form.contact-form, form.company-form, form.info-form"
  );

  if (!forms.length) return;

  forms.forEach(function(form) {
    form.addEventListener("submit", function() {
      window.dataLayer = window.dataLayer || [];

      // Päätellään lomaketyyppi class-listasta
      const classes = form.className || "";
      let formType = null;
      if (classes.includes("contact-form")) formType = "contact-form";
      else if (classes.includes("company-form")) formType = "company-form";
      else if (classes.includes("info-form")) formType = "info-form";

      window.dataLayer.push({
        event: "form_submit",
        form_type: formType,                  // contact-form / company-form / info-form
        form_id: form.id || null,             // jos id on asetettu
        form_classes: classes,                // koko class-lista varmuuden vuoksi
        page_path: window.location.pathname   // sivu, jolla lomake lähetettiin
      });
    });
  });
});

*/